import { generateDynamicThemeToken } from '../../ThemeProvider';
import { getDynamicThemeToken } from './theme';
import { randomStr } from '../../Shared';
const componentName = 'Checkbox';
export const checkboxClasses = {
    root: `ui-Checkbox-root-${randomStr()}`,
    title: `ui-Checkbox-title`,
    label: `ui-Checkbox-label`,
    description: `ui-Checkbox-description`,
    base: `ui-Checkbox-base`,
    pressed: `ui-Checkbox-pressed`,
};
export function getStyle(theme, opts) {
    const dynamicToken = getDynamicThemeToken(theme);
    const [token, tk] = generateDynamicThemeToken({
        componentName,
        theme,
        dynamicToken,
    });
    const rootStyle = {
        [`&.${checkboxClasses.root}`]: {
            display: 'inline-flex',
            flexDirection: 'column',
            [`& .${checkboxClasses.title}`]: {
                display: 'inline-flex',
                alignItems: 'center',
                cursor: opts?.disabled ? 'not-allowed' : 'pointer',
                fontFamily: tk(token.fontFamily),
                '&:focus': {
                    outline: 'none',
                },
            },
            [`& .${checkboxClasses.base}`]: {
                padding: tk(token.baseCheckboxPadding),
                alignSelf: 'flex-start',
            },
            [`& .${checkboxClasses.label}`]: {
                marginInlineStart: tk(token.checkboxLabelMarginLeft),
                color: opts?.disabled
                    ? tk(token.checkboxLabelDisabledColor)
                    : tk(token.checkboxLabelColor),
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '20px',
            },
            [`& .${checkboxClasses.description}`]: {
                marginInlineStart: tk(token.baseCheckboxWidth +
                    token.baseCheckboxPadding * 2 +
                    token.checkboxLabelMarginLeft),
                marginTop: tk(token.descriptionMarginTop),
                color: opts?.disabled
                    ? tk(token.checkboxLabelDisabledColor)
                    : tk(token.descriptionColor),
                fontSize: tk(token.descriptionFontSize),
                fontWeight: tk(token.descriptionFontWeight),
                lineHeight: tk(token.descriptionLineHeight),
                '&:empty': {
                    display: 'none',
                },
            },
        },
    };
    return rootStyle;
}
export function getIconStyle(theme) {
    const dynamicToken = getDynamicThemeToken(theme);
    const [token, tk] = generateDynamicThemeToken({
        componentName,
        theme,
        dynamicToken,
    });
    return {
        display: 'flex',
        boxSizing: 'border-box',
        borderRadius: tk(token.baseCheckboxBorderRadius),
        width: tk(token.baseCheckboxWidth),
        height: tk(token.baseCheckboxHeight),
        border: `1px solid ${tk(token.checkboxBorderColor)}`,
        backgroundColor: 'unset',
        'input:hover ~ &': {
            border: `1px solid ${tk(token.checkboxHoverBorderColor)}`,
            backgroundColor: tk(token.checkboxHoverBgColor),
        },
        [`input:active ~ &, .${checkboxClasses.pressed} input ~ &`]: {
            border: `1px solid ${tk(token.checkboxActiveBorderColor)}`,
            backgroundColor: tk(token.checkboxPressBgColor),
        },
        'input:disabled ~ &': {
            border: `1px solid ${tk(token.checkboxDisabledBorderColor)}`,
            backgroundColor: tk(token.checkboxDisabledBgColor),
        },
        [`.${checkboxClasses.root} .${checkboxClasses.title} input:focus-visible:not(:disabled) ~ &`]: {
            boxShadow: tk(token.checkboxFocusBoxShadow),
        },
    };
}
export function getCheckedIconStyle(theme) {
    const dynamicToken = getDynamicThemeToken(theme);
    const [token, tk] = generateDynamicThemeToken({
        componentName,
        theme,
        dynamicToken,
    });
    return {
        border: 'none',
        position: 'relative',
        'input ~ &': {
            backgroundColor: tk(token.checkboxCheckedBgColor),
            color: '#fff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            svg: {
                fontSize: 20,
                position: 'absolute',
            },
        },
        'input:hover ~ &': {
            border: 'none',
            backgroundColor: tk(token.checkboxCheckedHoverBgColor),
        },
        [`input:active ~ &, .${checkboxClasses.pressed} input ~ &`]: {
            border: 'none',
            backgroundColor: tk(token.checkboxCheckedActiveBgColor),
        },
        'input:disabled ~ &': {
            border: 'none',
            backgroundColor: tk(token.checkboxCheckedDisabledBgColor),
        },
    };
}
